module.exports = __webpack_public_path__ + "static/media/arrow-back.c0c5c509.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/arrow-back.svg
// module id = 463
// module chunks = 0